import React from 'react';
import { useTranslation } from 'react-i18next';
import { Building2, Network, Shield, Power, Server, MapPin } from 'lucide-react';

export function DatacenterShowcase() {
  const { t } = useTranslation();

  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">{t('datacenters.title')}</h2>
          <p className="text-xl text-gray-600">{t('datacenters.subtitle')}</p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12">
          {/* Milan Datacenter */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center gap-3 mb-6">
              <Building2 className="w-6 h-6 text-blue-600" />
              <div>
                <h3 className="text-xl font-bold">{t('datacenters.milan.name')}</h3>
                <p className="text-gray-600">{t('datacenters.milan.provider')}</p>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-center gap-3">
                <MapPin className="w-6 h-6 text-blue-600" />
                <div>
                  <h3 className="text-lg font-semibold">{t('datacenters.milan.address')}</h3>
                  <p className="text-gray-600">{t('datacenters.milan.city')}</p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-gray-50 rounded-xl p-6">
                  <Network className="w-8 h-8 text-blue-600 mb-3" />
                  <h4 className="font-semibold mb-2">{t('datacenters.milan.features.network.title')}</h4>
                  <p className="text-gray-600">{t('datacenters.milan.features.network.description')}</p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <Shield className="w-8 h-8 text-blue-600 mb-3" />
                  <h4 className="font-semibold mb-2">{t('datacenters.milan.features.security.title')}</h4>
                  <p className="text-gray-600">{t('datacenters.milan.features.security.description')}</p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <Power className="w-8 h-8 text-blue-600 mb-3" />
                  <h4 className="font-semibold mb-2">{t('datacenters.milan.features.power.title')}</h4>
                  <p className="text-gray-600">{t('datacenters.milan.features.power.description')}</p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <Shield className="w-8 h-8 text-blue-600 mb-3" />
                  <h4 className="font-semibold mb-2">{t('datacenters.milan.features.monitoring.title')}</h4>
                  <p className="text-gray-600">{t('datacenters.milan.features.monitoring.description')}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Falkenstein Datacenter */}
          <div className="bg-white rounded-xl shadow-lg p-8">
            <div className="flex items-center gap-3 mb-6">
              <Building2 className="w-6 h-6 text-blue-600" />
              <div>
                <h3 className="text-xl font-bold">{t('datacenters.falkenstein.name')}</h3>
                <p className="text-gray-600">{t('datacenters.falkenstein.provider')}</p>
              </div>
            </div>

            <div className="space-y-6">
              <div className="flex items-center gap-3">
                <MapPin className="w-6 h-6 text-blue-600" />
                <div>
                  <h3 className="text-lg font-semibold">{t('datacenters.falkenstein.address')}</h3>
                  <p className="text-gray-600">{t('datacenters.falkenstein.city')}</p>
                </div>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div className="bg-gray-50 rounded-xl p-6">
                  <Network className="w-8 h-8 text-blue-600 mb-3" />
                  <h4 className="font-semibold mb-2">{t('datacenters.falkenstein.features.network.title')}</h4>
                  <p className="text-gray-600">{t('datacenters.falkenstein.features.network.description')}</p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <Shield className="w-8 h-8 text-blue-600 mb-3" />
                  <h4 className="font-semibold mb-2">{t('datacenters.falkenstein.features.security.title')}</h4>
                  <p className="text-gray-600">{t('datacenters.falkenstein.features.security.description')}</p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <Power className="w-8 h-8 text-blue-600 mb-3" />
                  <h4 className="font-semibold mb-2">{t('datacenters.falkenstein.features.power.title')}</h4>
                  <p className="text-gray-600">{t('datacenters.falkenstein.features.power.description')}</p>
                </div>

                <div className="bg-gray-50 rounded-xl p-6">
                  <Server className="w-8 h-8 text-blue-600 mb-3" />
                  <h4 className="font-semibold mb-2">{t('datacenters.falkenstein.features.storage.title')}</h4>
                  <p className="text-gray-600">{t('datacenters.falkenstein.features.storage.description')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}